import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

import DashboardHeader from "./dashboardHeader";
import DashBoardContainer from "../../components/containers/dashboardContainer";
import ReviewCard from "../../components/reviewCard";
import ier_logo from "../../assets/images/icons/ier-logo2.png";
import download_icon from "../../assets/images/icons/download-icon.png";
import {
  submitIndividualApplication,
  updateIndividualApplication,
  fetchFile,
  fetchIndividualApplicationReport,
} from "../../actions";
import {
  SUBMIT_APPLICATION_ID,
  GENERATE_FILE_STRING_ID,
} from "../../store/loaders";
import LoadingSpinner from "../../components/loadingSpiner";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PdfReport from "../../components/downloadPdf/pdfIndividualReport";
import close_icon from "../../assets/images/icons/close.png";

const ApplicationReviewDetails = React.forwardRef((props, ref) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const apiResponse = useSelector((state) => {
    const {
      individualApplication,
      loader,
      hasUpdatedIndividualApplication,
      submittedApplication,
      fetchFile,
      individualApplicationReport,
    } = state;
    const { application } = individualApplicationReport;
    const { isLoading } = loader[SUBMIT_APPLICATION_ID] || { isLoading: false };
    const { message } = hasUpdatedIndividualApplication;
    const { response } = submittedApplication;
    const { file } = fetchFile;
    const fileLoader = loader[GENERATE_FILE_STRING_ID];

    return {
      application,
      isLoading,
      message,
      response,
      file,
      fileLoader,
    };
  });

  const [hasDownloaded, setHasDownloaded] = useState(false);
  const [download, setDownload] = useState(false);
  const [requiredFields, setRequiredFields] = useState([]);

  const applicationId =
    apiResponse.application?.applicationId || apiResponse.application?.id;
  const appId = props.location.state && props.location.state.application?.id;
  const message = props.location?.state?.message;
  const actionLoader = apiResponse.isLoading;
  var currentUser = JSON.parse(localStorage.getItem("currentUser"));
  var firstName = currentUser.given_name;
  var lastName = currentUser.family_name;

  const [applicationDetails, setApplicationDetails] = useState({});
  const [requestId, setRequestId] = useState("");

  useEffect(() => {
    if (apiResponse.file?.fileText != null && !hasDownloaded && download) {
      var a = document.createElement("a");
      a.href =
        "data:image/" +
        apiResponse.file?.type +
        ";base64," +
        apiResponse.file?.fileText;
      a.download =
        apiResponse.file?.name || "File" + "." + apiResponse.file?.type || "";
      a.click();
      setHasDownloaded(true);
    }
  }, [apiResponse.file]);

  useEffect(() => {
    dispatch(fetchIndividualApplicationReport(appId));
    if (
      apiResponse.message === requestId &&
      apiResponse.response?.status === "success"
    ) {
      // if (applicationDetails?.status?.toLowerCase().includes("rejected")) {
      //   history.push('/dashboard')
      // } 
      if(applicationDetails?.status?.toLowerCase().includes("payment")){
        history.push({
          pathname: "/applicant/payment-details",
          state: {
            application: applicationDetails,
            isFirm: false,
          },
        });
      }else{
        history.push('/dashboard')
      }
    }
  }, [apiResponse.message]);

  useEffect(() => {
    if (apiResponse.application) {
      setApplicationDetails({
        ...apiResponse.application,
      });
    }
  }, [apiResponse.application]);

  const handleSaveForLater = () => {
    history.push("/dashboard");
  };

  const handleSubmit = () => {
    const reqId = uuidv4();
    setRequestId(reqId);
    let applicationStatus = 'submitted'
    if(applicationDetails?.status?.toLowerCase().includes('rejected')){
        applicationStatus = 'Pending for review'
    }
    const sentItemms = {
      ...applicationDetails,
      status: applicationStatus,
      step: 7,
    };
    if (
      applicationDetails.membershipClassId?.id === "" ||
      applicationDetails.membershipClassId === null
    ) {
      requiredFields.push("Membership Class");
    }
    if (
      applicationDetails.discipline?.id === "" ||
      applicationDetails.discipline === null
    ) {
      requiredFields.push("Discipline");
    }
    if (
      applicationDetails.contactTelephoneNumber === "" ||
      applicationDetails.contactTelephoneNumber === null
    ) {
      requiredFields.push("Main Phone Number");
    }
    if (
      applicationDetails.contactEmail === "" ||
      applicationDetails.contactEmail === null
    ) {
      requiredFields.push("Main Email Address");
    }
    if (
      applicationDetails.secondaryContactTelephoneNumber === "" ||
      applicationDetails.secondaryContactTelephoneNumber === null
    ) {
      requiredFields.push("Next of kin Phone number");
    }
    if (
      applicationDetails.secondaryContactEmail === "" ||
      applicationDetails.secondaryContactEmail === null
    ) {
      requiredFields.push("Next of kin Email");
    }

    if (applicationDetails.residenceType === "Local") {
      if (
        applicationDetails.provinceId === "" ||
        applicationDetails.provinceId === null
      ) {
        requiredFields.push("Province");
      }
      if (
        applicationDetails.districtId === "" ||
        applicationDetails.districtId === null
      ) {
        requiredFields.push("District");
      }
      if (
        applicationDetails.sectorId === "" ||
        applicationDetails.sectorId === null
      ) {
        requiredFields.push("Sector");
      }
      if (
        applicationDetails.villageId === "" ||
        applicationDetails.villageId === null
      ) {
        requiredFields.push("Village");
      }
    }
    if (applicationDetails.residenceType === "Foreigner") {
      if (
        applicationDetails.countryOfResidence === "" ||
        applicationDetails.countryOfResidence === null
      ) {
        requiredFields.push("Country of residence");
      }
      if (
        applicationDetails.residenceAddress === "" ||
        applicationDetails.residenceAddress === null
      ) {
        requiredFields.push("Residence address");
      }
    }
    if (
      applicationDetails.educationDetails === null ||
      applicationDetails.educationDetails?.length <= 0
    ) {
      requiredFields.push("Educational details");
    }
    if (applicationDetails.membershipClassId?.id === 1) {
      if (
        applicationDetails.professionalReferences === null ||
        applicationDetails.professionalReferences?.length <= 0
      ) {
        requiredFields.push("Professional reference");
      }
    }
    if (
      applicationDetails.academicReferences === null ||
      applicationDetails.academicReferences?.length <= 0
    ) {
      requiredFields.push("Academic reference");
    }
    if (requiredFields.length <= 0) {
      if (applicationId) {
        dispatch(
          updateIndividualApplication({
            data: {
              ...sentItemms,
            },
            id: applicationId,
            reqId: reqId,
          })
        );
      } else {
        dispatch(
          submitIndividualApplication({
            data: {
              ...applicationDetails,
            },
            reqId: reqId,
          })
        );
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleCancel = () => {
    history.push({
      pathname: "/applicant/reference-details",
      state: {
        application: applicationDetails,
      },
    });
  };

  const downloadIdFile = () => {
    let url;
    if (
      applicationDetails?.documentFile?.fileText !== "" &&
      applicationDetails?.documentFile?.fileText !== undefined
    ) {
      url = encodeURIComponent(
        applicationDetails.documentFile?.fileText.substring(
          applicationDetails.documentFile?.fileText.indexOf("/tmp"),
          applicationDetails.documentFile?.fileText.length
        )
      );
      dispatch(fetchFile(url));
    }
    setDownload(true);
    setHasDownloaded(false);
  };

  const downloadCv = () => {
    let url;
    if (
      applicationDetails?.cv?.fileText !== "" &&
      applicationDetails?.cv?.fileText !== undefined
    ) {
      url = encodeURIComponent(
        applicationDetails.cv?.fileText.substring(
          applicationDetails.cv?.fileText.indexOf("/tmp"),
          applicationDetails.cv?.fileText.length
        )
      );
      dispatch(fetchFile(url));
    }
    setDownload(true);
    setHasDownloaded(false);
  };

  const downloadReport = () => {
    let url;
    if (
      applicationDetails?.technicalReportFile?.fileText !== "" &&
      applicationDetails?.technicalReportFile?.fileText !== undefined
    ) {
      url = encodeURIComponent(
        applicationDetails.technicalReportFile?.fileText.substring(
          applicationDetails.technicalReportFile?.fileText.indexOf("/tmp"),
          applicationDetails.technicalReportFile?.fileText.length
        )
      );
      dispatch(fetchFile(url));
    }
    setDownload(true);
    setHasDownloaded(false);
  };
  const downloadFile = (value) => {
    let url;
    if (value.awardDocumentFile) {
      if (
        value?.awardDocumentFile?.fileText !== "" &&
        value?.awardDocumentFile?.fileText !== undefined
      ) {
        url = encodeURIComponent(
          value.awardDocumentFile?.fileText.substring(
            value.awardDocumentFile?.fileText.indexOf("/tmp"),
            value.awardDocumentFile?.fileText.length
          )
        );
        dispatch(fetchFile(url));
      }
    }
    if (value.certificateDocumentFile) {
      if (
        value?.certificateDocumentFile?.fileText !== "" &&
        value?.certificateDocumentFile?.fileText !== undefined
      ) {
        url = encodeURIComponent(
          value.certificateDocumentFile?.fileText.substring(
            value.certificateDocumentFile?.fileText.indexOf("/tmp"),
            value.certificateDocumentFile?.fileText.length
          )
        );
        dispatch(fetchFile(url));
      }
    }
    setDownload(true);
    setHasDownloaded(false);
  };

  return (
    <div ref={ref}>
      <DashboardHeader activeStep={7} application={applicationDetails} />
      <DashBoardContainer
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        handleSaveForLater={handleSaveForLater}
        loader={apiResponse.fileLoader?.isLoading}
        isFetching={actionLoader}
        title="Submit"
        borderLess={true}
        hasButton={apiResponse.application ? false : true}
        middleTitle="Save for Later"
      >
        {/* <DownloadFile/> */}
        {requiredFields.length > 0 && (
          <div className="require-fields-container">
            <div className="d-flex">
              <div className="img-container">
                <img src={close_icon} onClick={() => setRequiredFields([])} />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                {requiredFields.map((el) => {
                  return <li>{el} is required</li>;
                })}
              </div>
            </div>
          </div>
        )}
        <div className="d-flex mb-2">
          <span
            className="dashboard-green-text-header"
            style={{ margin: "auto" }}
          >
            Review application details
          </span>
        </div>
        {apiResponse.application ? (
          <div className="dashboard-review-container">
            <div className="dashboard-review-title-container">
              <div
                style={{
                  width: "10%",
                }}
              >
                <img src={ier_logo} />
              </div>
              <div
                style={{
                  width: "30%",
                }}
              >
                <span className="review-header-title-text">
                  INSTITUTION OF ENGINEERS RWANDA
                </span>
                <br />
                <span className="review-sub-title">
                  Kimihurura - KG 666st Kigali-Rwanda <br />
                  P.o.Box 4386 Kigali Rwanda <br />
                  Telephone:
                  <span
                    style={{
                      fontWeight: "bold",
                      marginLeft: 2,
                    }}
                  >
                    (+250) 789 904 228
                  </span>
                  - Email:
                  <span
                    style={{
                      fontWeight: "bold",
                      marginLeft: 2,
                    }}
                  >
                    info@engineersrwanda.rw
                  </span>
                  - website:
                  <span
                    style={{
                      fontWeight: "bold",
                      marginLeft: 2,
                    }}
                  >
                    https://www.engineersrwanda.rw
                  </span>
                </span>
              </div>
              {message?.status?.toLowerCase().includes('rejected') && (
                <div
                  style={{
                    width: "30%",
                    border: "1px solid red",
                    padding: "30px 20px",
                    display: "flex",
                    flexDirection: "column",
                    marginRight: 30,
                  }}
                >
                  <span>Status: {message?.status}</span>
                  <div>
                    <span>Message: </span>
                    <span
                      style={{
                        color: "red",
                        fontSize: 16,
                        fontWeight: "bold",
                      }}
                    >
                       {applicationDetails?.latestComment || '-'}
                    </span>
                </div>
                  <span> Date: {message?.date}</span>
                </div>
              )}
              <div
                style={{
                  width: "30%",
                  display: "flex",
                  wordWrap: "break-word",
                }}
              >
                <span className="review-header-apllication-text">
                  APPLICATION DETAILS <br />
                  for <br />
                  <span
                    style={{
                      fontSize: "1.5rem",
                    }}
                  >
                    {applicationDetails.membershipClassId?.name}
                  </span>
                </span>
              </div>
            </div>
            <div>
              <ReviewCard
                title="Personal details"
                path="/applicant/personal-details"
                state={applicationDetails}
              >
                <div className="review-details-content-conatiner">
                  <div className="review-details-profile-container">
                    <div className="review-details-profile-icon">
                      {applicationDetails.portraitPhotoFile && (
                        <img
                          src={`data:image/${applicationDetails.portraitPhotoFile?.type};base64,${applicationDetails.portraitPhotoFile?.fileText}`}
                          style={{ width: "100%", height: "80%" }}
                        />
                      )}
                  </div>
                    <div>
                      <div>
                        <span>Title</span>
                        <p>{applicationDetails?.title}</p>
                      </div>
                      <div>
                        <span>First Name</span>
                        <p>{applicationDetails?.lastname || firstName}</p>
                      </div>
                      <div>
                        <span>Last Name</span>
                        <p>{applicationDetails?.firstname || lastName}</p>
                      </div>
                      <div>
                        <span>Gender</span>
                        <p>{applicationDetails?.gender}</p>
                      </div>
                    </div>
                  </div>

                  <div className="review-details-gender-details">
                    <div>
                      <span>Date of Birth</span>
                      <p>
                        {applicationDetails.dateOfBirth &&
                          moment(applicationDetails?.dateOfBirth)?.format(
                            "MMMM Do YYYY"
                          )}
                      </p>
                    </div>
                    <div>
                      <span>Nationality</span>
                      <p>{applicationDetails?.countryFrom?.name}</p>
                    </div>
                    <div>
                      <span>Discipline</span>
                      <p>{applicationDetails?.discipline?.name}</p>
                    </div>
                    <div>
                      <span>Education Level</span>
                      <p>{applicationDetails?.awardType?.name}</p>
                    </div>
                  </div>

                  <div className="review-details-id-type">
                    <div>
                      <span>ID Type</span>
                      <p>{applicationDetails?.identificationDocumentType}</p>
                    </div>
                    <div>
                      <span>ID Number</span>
                      <p>{applicationDetails?.identificationDocumentNumber}</p>
                    </div>

                    <div className="review-details-id-card-container">
                      <span>ID Card Scan Attached </span>
                      <div className="d-flex">
                        <p>{applicationDetails.documentFile?.name}</p>
                        {applicationDetails.documentFile && (
                          <img
                            src={download_icon}
                            onClick={downloadIdFile}
                            style={{
                              height: 40,
                              width: 40,
                              padding: 5,
                              marginLeft: 10,
                              cursor: "pointer",
                              marginTop: "-10px",
                            }}
                          />
                        )}
                      </div>
                      {/* <img src={`data:image/${applicationDetails.documentFile?.type};base64,${applicationDetails.documentFile?.fileText}`}/> */}
                    </div>
                    <div className="review-details-id-card-container">
                      <span>CV </span>
                      <div className="d-flex">
                        <p>{applicationDetails.cv?.name}</p>
                        {applicationDetails.cv && (
                          <img
                            src={download_icon}
                            onClick={downloadCv}
                            style={{
                              height: 40,
                              width: 40,
                              padding: 5,
                              marginLeft: 10,
                              cursor: "pointer",
                              marginTop: "-10px",
                            }}
                          />
                        )}
                      </div>
                      {/* <img src={`data:image/${applicationDetails.documentFile?.type};base64,${applicationDetails.documentFile?.fileText}`}/> */}
                    </div>
                    {applicationDetails.technicalReportFile && (
                      <div className="review-details-id-card-container">
                        <span>Technical Report</span>
                        <div className="d-flex">
                          <p>{applicationDetails.technicalReportFile?.name}</p>
                          <img
                            src={download_icon}
                            onClick={downloadReport}
                            style={{
                              height: 40,
                              width: 40,
                              padding: 5,
                              marginLeft: 10,
                              cursor: "pointer",
                              marginTop: "-10px",
                            }}
                          />
                        </div>
                        {/* <img src={`data:image/${applicationDetails.documentFile?.type};base64,${applicationDetails.documentFile?.fileText}`}/> */}
                      </div>
                    )}
                  </div>
                </div>
              </ReviewCard>

              <ReviewCard
                title="Contact details"
                path="/applicant/contact-details"
                state={applicationDetails}
              >
                <div className="review-details-content-conatiner">
                  <div className="review-details-contact-container-first">
                    <div className="d-flex">
                      <div className="contancts-container">
                        <div>
                          <span>Main Phone Number</span>
                          <p>
                            {applicationDetails?.contactTelephoneNumber || "-"}
                          </p>
                        </div>
                      </div>
                      <div className="">
                        <div>
                          <span>Main Email Address</span>
                          <p>{applicationDetails?.contactEmail || "-"}</p>
                        </div>
                      </div>
                    </div>
                    <div className="seperator-contact"></div>
                    <div className="d-flex">
                      <div className="contancts-container">
                        <div>
                          <span>Next of Kin Phone Number</span>
                          <p>
                            {applicationDetails?.secondaryContactTelephoneNumber ||
                              "-"}
                          </p>
                        </div>
                      </div>
                      <div className="">
                        <div>
                          <span>Next of Kin Email Address</span>
                          <p>
                            {applicationDetails?.secondaryContactEmail || ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="review-details-contact-container-second">
                    <div className="">
                      <div style={{ wordWrap: "break-word" }}>
                        <span>Residence Address</span>
                        {applicationDetails.residenceType === "Local" ? (
                          <p>
                            {applicationDetails.provinceId?.name},
                            {applicationDetails.districtId?.name},
                            {applicationDetails.sectorId?.name},
                            {applicationDetails.cellId?.name},
                            {applicationDetails.villageId?.name},
                            {applicationDetails.streetOrHouseNumber}
                          </p>
                        ) : (
                          <p>
                            {applicationDetails.countryOfResidence?.name},{" "}
                            {applicationDetails.residenceAddress}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </ReviewCard>
              <ReviewCard
                title="Educational details"
                path="/applicant/educational-details"
                state={applicationDetails}
              >
                <div className="review-details-content-conatiner">
                  <div
                    className="review-details-contact-container-first"
                    style={{ width: "100%" }}
                  >
                    {applicationDetails.educationDetails?.length > 0 && (
                      <div>
                        {applicationDetails.educationDetails.map((value) => {
                          return (
                            <div
                              className="d-flex dashboarder-grey-contanier mt-4"
                              style={{ justifyContent: "space-between" }}
                            >
                              <div>
                                <div>
                                  <span>Institution Name</span>
                                  <p>{value.institutionName}</p>
                                </div>
                              </div>
                              <div className="">
                                <div>
                                  <span>Award Type</span>
                                  <p>
                                    {value.awardTypeId?.name ||
                                      value.awardType?.name}
                                  </p>
                                </div>
                              </div>
                              <div className="">
                                <div>
                                  <span>Year of Award</span>
                                  <p>{value.yearOfAward}</p>
                                </div>
                              </div>
                              <div className="mb-4">
                                <span>Certified Award Attached</span>
                                <div
                                  className="d-flex"
                                  style={{ alignItems: "center" }}
                                >
                                  <p>{value.awardDocumentFile?.name}</p>
                                  {value.awardDocumentFile?.fileText && (
                                    <img
                                      src={download_icon}
                                      onClick={() => downloadFile(value)}
                                      style={{
                                        height: 40,
                                        width: 40,
                                        padding: 5,
                                        marginLeft: 10,
                                        cursor: "pointer",
                                        marginTop: "-20px",
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        <div
                          className="seperator-contact"
                          style={{ width: "100%" }}
                        ></div>
                      </div>
                    )}
                  </div>
                </div>
              </ReviewCard>
              <ReviewCard
                title="CERTIFICATION DETAILS"
                path="/applicant/certificate-details"
                state={applicationDetails}
              >
                <div className="review-details-content-conatiner">
                  <div
                    className="review-details-contact-container-first"
                    style={{ width: "100%" }}
                  >
                    {applicationDetails.professionalCertificates?.length >
                      0 && (
                      <div>
                        {applicationDetails.professionalCertificates.map(
                          (value) => {
                            return (
                              <div
                                className="d-flex dashboarder-grey-contanier mt-4"
                                style={{ justifyContent: "space-between" }}
                              >
                                <div>
                                  <div>
                                    <span>Certificate Name</span>
                                    <p>{value.name}</p>
                                  </div>
                                </div>
                                <div className="">
                                  <div>
                                    <span>Provider</span>
                                    <p>{value.provider}</p>
                                  </div>
                                </div>
                                <div className="">
                                  <div>
                                    <span>Location</span>
                                    <p>{value.location}</p>
                                  </div>
                                </div>
                                <div className="">
                                  <div>
                                    <span>Start Date</span>
                                    <p>
                                      {moment(value.startDate).format(
                                        "MMMM Do YYYY"
                                      )}
                                    </p>
                                  </div>
                                </div>
                                <div className="">
                                  <div>
                                    <span>End Date</span>
                                    <p>
                                      {moment(value.endDate).format(
                                        "MMMM Do YYYY"
                                      )}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-4">
                                  <span>Certified Award Attached</span>
                                  <div className="d-flex">
                                    <p>{value.certificateDocumentFile?.name}</p>
                                    {value.certificateDocumentFile
                                      ?.fileText && (
                                      <img
                                        src={download_icon}
                                        onClick={() => downloadFile(value)}
                                        style={{
                                          height: 40,
                                          width: 40,
                                          padding: 5,
                                          marginLeft: 10,
                                          cursor: "pointer",
                                          marginTop: "-10px",
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        )}
                        <div
                          className="seperator-contact"
                          style={{ width: "100%" }}
                        ></div>
                      </div>
                    )}
                  </div>
                </div>
              </ReviewCard>

              <ReviewCard
                title="REFERENCES DETAILS"
                path="/applicant/reference-details"
                state={applicationDetails}
              >
                <div className="review-details-content-conatiner">
                  <div
                    className="review-details-contact-container-first"
                    style={{ width: "100%" }}
                  >
                    {applicationDetails.professionalReferences?.length > 0 && (
                      <div>
                        {applicationDetails.professionalReferences.map(
                          (value) => {
                            return (
                              <div
                                className="d-flex dashboarder-grey-contanier mt-4"
                                style={{ justifyContent: "space-between" }}
                              >
                                <div>
                                  <div>
                                    <span>Full Names</span>
                                    <p>{value.name}</p>
                                  </div>
                                </div>
                                <div className="">
                                  <div>
                                    <span>Member Grade</span>
                                    <p>{value.memberGradeId}</p>
                                  </div>
                                </div>
                                <div className="">
                                  <div>
                                    <span>Member Number</span>
                                    <p>{value.ierMemberNumber}</p>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                    )}

                    <div
                      className="seperator-contact"
                      style={{ width: "100%" }}
                    ></div>
                    {applicationDetails.academicReferences?.length > 0 && (
                      <div>
                        {applicationDetails.academicReferences.map((value) => {
                          return (
                            <div
                              className="d-flex dashboarder-grey-contanier mt-4"
                              style={{ justifyContent: "space-between" }}
                            >
                              <div>
                                <div>
                                  <span>Full Names</span>
                                  <p>{value.name}</p>
                                </div>
                              </div>
                              <div className="">
                                <div>
                                  <span>Phone Number</span>
                                  <p>{value.telephoneNumber}</p>
                                </div>
                              </div>
                              <div className="">
                                <div>
                                  <span>Email Address</span>
                                  <p>{value.email}</p>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </ReviewCard>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: "10%",
            }}
          >
            <LoadingSpinner color={"#1D834F"} />
          </div>
        )}
      </DashBoardContainer>
      <div
        style={{
          marginBottom: 20,
          marginTop: 20,
        }}
      >
        <PDFDownloadLink
          document={<PdfReport data={applicationDetails} />}
          fileName="report.pdf"
          style={{
            backgroundColor: "#0E348A",
            padding: "15px 20px",
            marginLeft: 80,
            textDecoration: "none",
            color: "white",
          }}
        >
          {({ blob, url, loading, error }) =>
            loading ? "Loading document..." : "DownLoad PDF Report"
          }
        </PDFDownloadLink>
      </div>
    </div>
  );
});

export default ApplicationReviewDetails;
